var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    [
      _c(
        "gg-card-header",
        [
          _c("span", [_vm._v("AutoSSL Problems")]),
          _c(
            "gg-btn",
            {
              staticClass: "ml-2",
              attrs: {
                loading: _vm.loading,
                "aria-label": "Refresh Auto SSL Problems list."
              },
              on: {
                click: _vm.loadProblemsList
              }
            },
            [_c("v-icon", [_vm._v("mdi-refresh")])],
            1
          ),
          _c(
            "v-tooltip",
            {
              attrs: {
                bottom: ""
              },
              scopedSlots: _vm._u([
                {
                  key: "activator",
                  fn: function fn(_ref) {
                    var on = _ref.on
                    return [
                      _c(
                        "v-icon",
                        _vm._g(
                          {
                            staticClass: "ml-2",
                            attrs: {
                              color: "primary",
                              small: ""
                            }
                          },
                          on
                        ),
                        [_vm._v(" mdi-help-circle ")]
                      )
                    ]
                  }
                }
              ])
            },
            [
              _c("span", [
                _vm._v("Review certificates that had problems getting issued.")
              ])
            ]
          )
        ],
        1
      ),
      _c(
        "gg-card-text",
        [
          _c("v-data-table", {
            attrs: {
              headers: _vm.headers,
              loading: _vm.loading,
              items: _vm.autoSslProblems
            },
            scopedSlots: _vm._u([
              {
                key: "item.problem",
                fn: function fn(_ref2) {
                  var item = _ref2.item
                  return [
                    _c(
                      "div",
                      {
                        staticClass: "problem"
                      },
                      [_vm._v(" " + _vm._s(item.problem) + " ")]
                    )
                  ]
                }
              },
              {
                key: "item.time",
                fn: function fn(_ref3) {
                  var item = _ref3.item
                  return [_vm._v(" " + _vm._s(_vm.formatDate(item.time)) + " ")]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }